<ion-button fill="clear" color="primary" [title]="title" [attr.aria-label]="title" aria-haspopup="dialog"
    (click)="OnOpen()">
    <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
</ion-button>
